import React, { Fragment } from 'react';
import {
  SwipeableDrawer,
  Grid,
  IconButton,
  Typography,
  Icon,
  Button,
  withStyles,
} from '@material-ui/core';
import ReactExport from 'react-export-excel';
import { SelectUI, ToggleUI, DateTimeUI, ButtonUI } from '../../../common';
import { Validate, Config } from '../../../../other';
import DataExcelVentas from './DataExcelVentas.json';
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const es_iphone = Validate.is_iphone();

const parse_productos = (v_arr_carrito_json) => {
  let productos_prev = JSON.parse(v_arr_carrito_json);

  let productos = [];

  for (let idStock in productos_prev) {
    productos.push(productos_prev[idStock]);
  }
  return productos;
};

const productos_string = (product_list) => {
  let productos = [];
  product_list.forEach((product) => {
    let producto = `${product.cantidad}x ${product.nombre}`;
    if (product.atributos > 0) {
      let atributos_st = [];
      let atributos = product.info_atributos;
      for (let item in atributos) {
        let atributo = `${atributos[item].at_nombre}: ${atributos[item].vat_valor}`;
        atributos_st.push(atributo);
      }
      producto = `${producto} (${atributos_st.toString()})`;
    }

    producto = `${producto} (SKU: ${product.sku ? product.sku : '-'})`;

    productos.push(producto);
  });

  let productos_st = productos.toString();

  return productos_st;
};

const RenderExcel = ({ data, idCountry }) => {
  if (data.length > 0) {
    let date = Validate.now_format(Config.SHORTDATE_FORMAT_DASH);
    data = data.map((venta) => {
      let envio_seleccionado = JSON.parse(venta.v_arr_envio_seleccionado_json);
      let productos_list = parse_productos(venta.v_arr_carrito_json);
      let metodo_envio_extra = Validate.labels_metodo_envio_extra(
        venta.v_metodo_envio,
        envio_seleccionado
      );

      let v_facturacion_nombrecompleto = venta.v_facturacion_nombre;
      if (venta.v_facturacion_apellido) {
        v_facturacion_nombrecompleto += ' ' + venta.v_facturacion_apellido;
      }

      let envioCalle = Validate.trim_ucwords(venta.v_envio_calle);
      let facturacionCalle = Validate.trim_ucwords(venta.v_facturacion_calle);

      if (idCountry === 'COL') {
        envioCalle = venta.v_envio_calle + ' - ' + venta.v_envio_numero;

        facturacionCalle =
          venta.v_facturacion_calle + ' - ' + venta.v_facturacion_numero;
      }

      return {
        ...venta,
        v_fecha: Validate.utc2local_format(venta.v_fecha, Config.DATE_FORMAT),
        v_facturacion_nombrecompleto: Validate.trim_ucwords(
          v_facturacion_nombrecompleto
        ),
        cl_email: venta.cliente.cl_email,
        pago: Validate.label_estado_pago(venta.v_estado_pago),
        metodo_pago: Validate.label_metodo_pago(venta.v_metodo_pago),
        envio: Validate.label_estado_envio(
          venta.v_metodo_envio,
          venta.v_estado_envio
        ),
        metodo_envio: Validate.label_metodo_envio(
          venta.v_metodo_envio,
          envio_seleccionado
        ),
        v_monto: Validate.number_format_excel(venta.v_monto),
        costo_envio: Validate.number_format_excel(
          Validate.label_costo_envio_exportar(
            venta.v_metodo_envio,
            venta.v_envio_costo,
            venta.v_envio_gratis,
            envio_seleccionado
          )
        ),
        metodo_envio_tipo: metodo_envio_extra.tipo_envio,
        metodo_envio_tipo_sucursal: metodo_envio_extra.sucursal,
        v_envio_nombre: Validate.trim_ucwords(venta.v_envio_nombre),
        v_envio_apellido: Validate.trim_ucwords(venta.v_envio_apellido),
        v_envio_calle: envioCalle,
        v_envio_ciudad: Validate.trim_ucwords(venta.v_envio_ciudad),
        v_facturacion_calle: facturacionCalle,
        v_facturacion_ciudad: Validate.trim_ucwords(venta.v_facturacion_ciudad),
        productos: productos_string(productos_list),
        facturada: venta.v_factura ? 'Si' : 'No',
      };
    });

    return (
      <ExcelFile filename={`Exportacion-ventas-${date}`} hideElement={true}>
        <ExcelSheet data={data} name="Cupones">
          {DataExcelVentas[idCountry || 'ARG'].map(({ label, value }, idx) => {
            return <ExcelColumn label={label} value={value} key={idx} />;
          })}
        </ExcelSheet>
      </ExcelFile>
    );
  } else {
    return '';
  }
};

const FilterSidenav_ = (props) => {
  let {
    classes,
    filter,
    selects,
    filters_sidenav,
    handleDrawer,
    handleChangeSelect,
    limpiarFiltros,
    handleChangeDate,
    handleSubmitFilter,
    type,
    loading,
    data_exportar,
    idCountry,
  } = props;

  let { periodo_desde, periodo_hasta } = props.periodos;

  let selects_v_metodo_pago = props.selects.v_metodo_pago;
  let selects_v_metodo_envio = props.selects.v_metodo_envio;

  if (idCountry === 'COL') {
    selects_v_metodo_pago = [
      {
        label: 'Todos',
        value: 0,
      },
      {
        label: 'Ualá Bis',
        value: 7,
      },
      {
        label: 'Acordar',
        value: 3,
      },
    ];

    selects_v_metodo_envio = [
      {
        value: 0,
        label: 'Todos',
      },
      {
        value: 3,
        label: 'Acordar',
      },
      {
        value: 7,
        label: 'Email',
      },
    ];
  }

  return (
    <Fragment>
      <SwipeableDrawer
        anchor="right"
        open={filters_sidenav}
        onClose={() => handleDrawer(false, type)}
        onOpen={() => handleDrawer(true, type)}
        disableBackdropTransition={!es_iphone}
        disableDiscovery={es_iphone}
      >
        <div className={classes.filters_sidenav_box}>
          <Grid container spacing={16}>
            <Grid item xs={12}>
              <Grid container alignItems="center" spacing={8}>
                <Grid item>
                  <IconButton
                    aria-label="Cancelar"
                    onClick={() => handleDrawer(false, type)}
                  >
                    <Icon>clear</Icon>
                  </IconButton>
                </Grid>
                <Grid item>
                  <Typography variant="h6">
                    {type === 'filtrar' ? 'FILTRAR' : 'EXPORTAR'}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <SelectUI
                data={filter.v_metodo_pago}
                options={selects_v_metodo_pago}
                handleChangeSelect={handleChangeSelect}
              />
            </Grid>
            <Grid item xs={12}>
              <SelectUI
                data={filter.v_estado_pago}
                options={selects.v_estado_pago}
                handleChangeSelect={handleChangeSelect}
              />
            </Grid>
            <Grid item xs={12}>
              <SelectUI
                data={filter.v_metodo_envio}
                options={selects_v_metodo_envio}
                handleChangeSelect={handleChangeSelect}
              />
            </Grid>
            <Grid item xs={12}>
              <SelectUI
                data={filter.v_estado_envio}
                options={selects.v_estado_envio}
                handleChangeSelect={handleChangeSelect}
              />
            </Grid>
            <Grid item xs={12}>
              <SelectUI
                data={filter.v_archivada}
                options={selects.v_archivada}
                handleChangeSelect={handleChangeSelect}
              />
            </Grid>
            <Grid item xs={12}>
              <SelectUI
                data={filter.v_mayorista}
                options={selects.v_mayorista}
                handleChangeSelect={handleChangeSelect}
              />
            </Grid>
            <Grid item xs={12}>
              <SelectUI
                data={filter.v_factura}
                options={selects.v_factura}
                handleChangeSelect={handleChangeSelect}
              />
            </Grid>
            <Grid item xs={12}>
              <SelectUI
                data={filter.v_filtrar_fecha}
                options={selects.v_filtrar_fecha}
                handleChangeSelect={handleChangeSelect}
              />
            </Grid>
            <ToggleUI show={filter.v_filtrar_fecha.value === 1}>
              <Grid item xs={6}>
                <DateTimeUI
                  handleChangeDate={handleChangeDate}
                  inputdate={periodo_desde}
                />
              </Grid>
              <Grid item xs={6}>
                <DateTimeUI
                  handleChangeDate={handleChangeDate}
                  inputdate={periodo_hasta}
                />
              </Grid>
            </ToggleUI>
            <Grid item xs={12}>
              <ButtonUI
                type="callf"
                label={type === 'exportar' ? 'EXPORTAR' : 'APLICAR FILTROS'}
                size="large"
                isLoading={
                  type === 'exportar' ? loading.exportar : loading.ventas
                }
                onClickFunc={() =>
                  handleSubmitFilter(type, periodo_desde, periodo_hasta)
                }
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                onClick={(e) => limpiarFiltros()}
                variant="outlined"
                size="large"
                className={classes.button}
                fullWidth
              >
                <div className={classes.icon_center}>
                  <Icon className={classes.icon_badge}>delete</Icon>
                  LIMPIAR FILTROS
                </div>
              </Button>
            </Grid>
          </Grid>
        </div>
      </SwipeableDrawer>
      <RenderExcel data={data_exportar} idCountry={idCountry} />
    </Fragment>
  );
};

const styles = (theme) => ({
  icon_center: {
    display: 'flex',
    alignItems: 'center',
    padding: '3px 0px',
  },
  icon_badge: {
    marginRight: '10px',
  },
  button: {
    marginTop: '2px',
  },
  filters_sidenav_box: {
    width: '300px',
    padding: theme.spacing.unit * 2,
  },
});

export const FilterSidenav = withStyles(styles, { withTheme: true })(
  FilterSidenav_
);
